import { render, staticRenderFns } from "./MediaGridItem.vue?vue&type=template&id=23de1ade&scoped=true&"
import script from "./MediaGridItem.vue?vue&type=script&lang=js&"
export * from "./MediaGridItem.vue?vue&type=script&lang=js&"
import style0 from "./MediaGridItem.vue?vue&type=style&index=0&id=23de1ade&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23de1ade",
  null
  
)

export default component.exports